import type { DynamicDialogData } from '@bizzdesign/modeler/models';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import type { DynamicDialogConfig } from 'primeng/dynamicdialog';

/** Events for dialogs shown to peers while another user publishes a view. */
export const dialogPublishPeerUiEvents = eventGroup({
  source: 'Dialog Publish Peer UI',
  events: {
    publishingInProgressDialogOpened:
      type<DynamicDialogConfig<DynamicDialogData>>(),
    publishingFailureDialogOpened:
      type<DynamicDialogConfig<DynamicDialogData>>(),
    dialogClosed: type<void>(),
    workspaceOpened: type<void>(),
  },
});
